<template>
    <div>
        <div id="header">
            <img class="header-bg" src="../../assets/health/health.jpg" alt="">
            <div class="header-info">
                <div class="info-l">
                    <p>{{num}}</p>
                    <p>血糖(mmol/L)</p>
                </div>
                <div class="info-r">
                    <img :src='headimg' alt="">
                    <p>{{name}}</p>
                    <p>{{create_time}}</p>
                </div>
            </div>
        </div>
        <div id="content">
            <ul>
                <van-list>
                    <van-cell v-for="item in list" :key="item">
                        <li>
                            <span>{{item.bloodSugar}}mmol/L</span>
                            <label>{{item.create_time}}</label>
                        </li>
                    </van-cell>
                </van-list>
            </ul>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {List} from 'vant';

    Vue.use(List);

    import {bloodSugar} from '../../api/health';

    export default {
        name: "heartRate",
        data() {
            return {
                name: '',
                create_time: '',
                headimg: '',
                num: 0,
                list: [],
            };
        },
        mounted() {
            let _this = this;
            document.title = '血糖-健康管理';

            bloodSugar({token: this.$route.query.token})
                .then(res => {
                    if (res.code === 1) {
                        var X = [];
                        var Y = [];
                        res.content.list.forEach(function (item) {
                            X.push(item.create_time.split(' ')[1]);
                            Y.push(item.oxygen);
                        });
                        _this.name = res.content.info.name;
                        _this.headimg = res.content.info.headimg;
                        _this.create_time = res.content.info.create_time;
                        _this.num = res.content.info.bloodSugar;

                        _this.list = res.content.list;
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        }
    };

</script>
<style lang="scss" scoped>
    #header {
        width: 100%;
        height: 500px;
    }

    #header .header-bg {
        width: 100%;
    }

    #header .header-info .info-l {
        float: left;
        padding-left: 15px;
        padding-top: 5px;
        text-align: center;
    }

    #header .header-info .info-l p:nth-child(1) {
        font-weight: bold;
        color: #333;
        font-size: 34px;
    }

    #header .header-info .info-l p:nth-child(2) {
        color: #999;
        font-size: 13px;
    }

    #header .header-info .info-r {
        float: right;
        text-align: right;
        font-family: PingFang SC;
        position: absolute;
        right: 15px;
        top: 388px;
    }

    #header .header-info .info-r img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
    }

    #header .header-info .info-r p:nth-child(2) {
        font-weight: bold;
        color: #333;
        font-size: 15px;
        width: 67px;
        padding-left: 32px;
        text-align: center;
    }

    #header .header-info .info-r p:nth-child(3) {
        color: #999;
        font-size: 13px;
    }

    #content {
        width: 95%;
        margin: 20px auto;
    }
    #content ul li span {
        float: left;
        color: #333;
        font-size: 15px;
    }
    #content ul li label {
        float: right;
        color: #666;
        font-size: 12px;
    }
</style>
<style scoped>
    #content /deep/ .van-cell {
        padding: 5px;
    }
</style>